<div class="pl-page">

    <!-- ── Page header ───────────────────────────────── -->
    <div class="pl-header">
        <div class="pl-header-left">
            <h2 class="pl-title">Pricing plans</h2>
        </div>
        <div class="pl-header-actions">
            @if (activeTab === '0') {
            <button class="pl-btn pl-btn--primary" type="button" (click)="openAddPricingPlanDialog()">
                <i class="fa-solid fa-plus"></i> Add Plan
            </button>
            }
            @if (activeTab === '1') {
            <button class="pl-btn pl-btn--primary" type="button" (click)="openAddMileagePlanDialog()">
                <i class="fa-solid fa-plus"></i> Add Mileage
            </button>
            }
        </div>
    </div>

    <!-- ── Tabs ──────────────────────────────────────── -->
    <div class="pl-tabs">
        <button class="pl-tab" [class.pl-tab--active]="activeTab === '0'"
            (click)="onTabChange('0')" type="button">Pricing plans</button>
        <button class="pl-tab" [class.pl-tab--active]="activeTab === '1'"
            (click)="onTabChange('1')" type="button">Extra mileage</button>
    </div>

    <!-- ── Tab content ───────────────────────────────── -->
    <div class="pl-card">
        <div [hidden]="activeTab !== '0'">
            <app-pricing-plans-component
                (editPricingPlan)="openUpdatePricingPlanDialog($event)"
                (deletePricingPlan)="openDeletePricingPlanDialog($event)" />
        </div>
        <div [hidden]="activeTab !== '1'">
            <app-mileage-plan-component
                (editMileagePlan)="openUpdateMileagePlanDialog($event)"
                (deleteMileagePlan)="openDeleteMileagePlanDialog($event)" />
        </div>
    </div>

</div>

@defer (when addPricingPlanDialog; prefetch on idle) {
<app-add-plan-form (addedPlan)="onPlanAdded()" [(visibility)]="addPricingPlanDialog" />
}

@defer (when updatePricingPlanDialog; prefetch on idle) {
<app-update-pricing-plan-form [selectedPricingPlan]="selectedPricingPlan" [(visibility)]="updatePricingPlanDialog" (updatedPricingPlan)="onPricingPlanUpdated()" />
}

@defer (when deletePricingPlanDialog; prefetch on idle) {
<app-delete-pricing-plan-form [selectedPricingPlan]="selectedPricingPlan" [(visibility)]="deletePricingPlanDialog" (deletedPricingPlan)="onPricingPlanDeleted()" />
}

@defer (when addMileagePlanDialog; prefetch on idle) {
<app-add-mileage-plan-form (addedMileagePlan)="onMileagePlanAdded()" [(visibility)]="addMileagePlanDialog" />
}

@defer (when updateMileagePlanDialog; prefetch on idle) {
<app-update-mileage-plan-form [selectedMileagePlan]="selectedMileagePlan" [(visibility)]="updateMileagePlanDialog" (updatedMileagePlan)="onMileagePlanUpdated()" />
}

@defer (when deleteMileagePlanDialog; prefetch on idle) {
<app-delete-mileage-plan-form [selectedMileagePlan]="selectedMileagePlan" [(visibility)]="deleteMileagePlanDialog" (deletedMileagePlan)="onMileagePlanDeleted()" />
}
